import { getAdminUrl } from './getAdminUrl';
import { getCurrentOrg } from '../api/getCurrentOrg';

type GetExternalConversationUrlParams = {
  contactPhone?: string;
};

export const getExternalConversationUrl = ({
  contactPhone,
}: GetExternalConversationUrlParams) => {
  if (!contactPhone) return;
  const organization_id = getCurrentOrg();

  return `${getAdminUrl()}/conversation/?user_phone=${contactPhone}&organization_id=${organization_id}`;
};
